<p class="p2 block md:hidden">
  Need assistance? Call
  <a class="no-underline font-semibold" href="tel:{{ CcsConfig.helpPhone }}">{{ CcsConfig.helpPhone }}</a> or email
  <a class="no-underline font-semibold" href="mailto:{{ CcsConfig.helpEmail }}">{{ CcsConfig.helpEmail }}</a>
</p>
